import styled from 'styled-components'
import { breakpoints } from '../../../../MediasQueries'

export const Zone = styled.section`
  padding: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  border: 1px dashed ${(props) => props.theme.brand};
  box-sizing: border-box;
  height: 220px;
  border-radius: 4px;

  p:first-of-type {
    font-size: 50px;
    color: ${(props) => props.theme.brand};
  }
  h3:last-of-type {
    color: ${(props) => props.theme.brand};
    margin-bottom: 15px;
  }
  ${(props) =>
    props.isDragActive ? 'background-color:rgba(56, 211, 92,0.2); border-width:3px; `;' : null}
`
export const Actions = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
`
export const ListFiles = styled.div`
  margin: 6px 0px 10px 0px;

  ul {
    padding: 0;
    list-style-type: none;
    color: rgba(0, 0, 0, 0.8);

    li:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    span {
      padding: 4px 0px;
      display: flex;
      align-items: center;
    }
  }
`
export const Close = styled.button`
  margin-left: auto;
  display: none;

  /* O componente Close será exibido quando o elemento pai estiver em hover */
  li:hover & {
    display: inline;
  }
`
export const InfosWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  @media (max-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
  margin-top: auto;
  gap: 20px;

  button {
    font-size: 15px;
  }
`

export const ContentModal = styled.div`
  margin: 1vw;
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
`
